import {
  capitalize,
  compact, find, first, flatMap, forEach, groupBy, map, remove, sumBy
} from 'lodash'
import { produce } from 'immer'
import { ItemData } from '../apis/item.api'
import { ItemType } from '../apis/ItemType.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'
import { TableVerticalData } from '../components/TableVertical'

export default {
  tableHorizontalData (
    items: ItemData[]
  ): TableHorizontalData<ItemData>[] {
    forEach(items, (item: TableHorizontalData<ItemData>) => {
      const actions: ActionName[] = ['edit']
      if (!item.isDeleted) actions.push('delete')
      item.actions = actions
    })
    return items
  },

  locationSearchTableData (items: ItemData[]): TableHorizontalData<ItemData>[] {
    const itemsData = flatMap(items, item => {
      const palletGroup = groupBy(item.pallets, 'aliveTransfer.bin')
      return map(palletGroup, pallets => {
        return { ...item, pallets }
      })
    })
    forEach(itemsData, (item: TableHorizontalData<ItemData>) => {
      /**
       * Refactor required
       * The item id can be duplicated. When search location without
       * bin. So we passing palletId here. So it'll helpful when handle
       * view action to collect itemId and bin.
       */
      const firstPallet = first(item.pallets)
      if (firstPallet) {
        item.id = firstPallet.id
      }
      item.actions = ['view']
      if (!item.pallets) item.palletsQuantity = 0
      item.palletsQuantity = sumBy(item.pallets, 'quantity')
      return item
    })
    return itemsData
  },

  delete (items: TableHorizontalData<ItemData>[], id: number) {
    return produce(items, items => {
      remove(items, { id })
    })
  },

  selectOptions (items: ItemData[]) {
    return map(items, item => {
      const { code, id } = item
      return { name: code, value: String(id) }
    })
  },

  searchOptions (items: ItemData[]) {
    const itemsData = map(items, item => {
      const { code, id } = item
      return { id, value: code }
    })
    return compact(itemsData)
  },

  find (items: ItemData[], id: number) {
    return find(items, { id })
  },

  findByPalletId (items: ItemData[], palletId: number) {
    return find(items, item => {
      return find(item.pallets, { id: palletId })
    }) as ItemData | undefined
  },

  get types (): ItemType[] {
    return ['production', 'receivable']
  },

  get typeChecks () {
    return map(this.types, type => {
      return {
        name: type,
        label: capitalize(type)
      }
    })
  },

  productionTotalCalculationData (item: ItemData, quantity: number)
    : TableVerticalData {
    const pallets = quantity / item.cpp
    const cases = quantity
    const units = item.qpc * quantity
    return { pallets, cases, units }
  }
}
